import OAuth2Service from 'external-services/oauth-login/OAuth2.service';

const NS = 'UnauthorisedDialogCtrl';

export default function UnauthorisedDialogCtrl(
  $scope, $mdDialog, AuthService
) {
  "ngInject";

  $scope.login = function() {

    if (window.config.enableOAuth2 && OAuth2Service.getIsEnableOAuth()) {
      OAuth2Service.logout().finally(() => {
        OAuth2Service.removeStoredDataForOauth();
        AuthService.logout();
      });
    } else {
      AuthService.logout();
    }
    $mdDialog.hide();
  };
}
